export default ({ COLORS }) => ({
  remove: {
    color: COLORS.RED.NORMAL
  },
  moreButton: {
    padding: '7px 10px',
    fontSize: '14px',
    background: '#00afec',
    border: 'none',
    color: '#fff',
    fontWeight: 'bold',
    width: 'auto',
    height: 'auto',
    '&:hover': {
      opacity: '0.8'
    },
    '&:hover>svg': {
      color: '#fff !important'
    },
    '&:after': {
      content: '"Review" !important'
    },
    '& svg': {
      color: '#fff',
      marginRight: '5px'
    }
  }
})
